







import { defineComponent, ref, onActivated, onDeactivated, onMounted, onUnmounted, watch } from '@vue/composition-api';
import ViewContainer from '@/components/ViewContainer.vue';
import TrackInfoPage from '@/components/storyblok/TrackInfoPage.vue';
import AboutPage from '@/components/storyblok/AboutPage.vue';
import AudioTracks from '@/components/storyblok/AudioTracks.vue';
import { getStory, pingEditor, isInEditor, storyblokEventManager } from '@/storyblok';

export default defineComponent({
  name: 'TrackInfo',
  components: { ViewContainer, TrackInfoPage, AudioTracks, AboutPage },
  props: {
    editorOnly: {
      type: Boolean,
      default: false,
    },
    noView: {
      type: Boolean,
      default: false,
    },
    slug: { type: String },
  },
  // async setup not available in vue 2 but it is in vue 3...
  setup(props, ctx) {
    const story = ref({
      content: {},
    });

    const _getStory = async (slug: string, version?: string) => {
      try {
        story.value = await getStory(slug, version);
      } catch (e) {
        console.error(e);
      }
    };

    async function getStoryDraft() {
      await _getStory(props.slug || ctx.root.$route.path, 'draft');
    }

    async function getStoryPublished() {
      await _getStory(props.slug || ctx.root.$route.path, 'published');
    }

    // eslint-disable-next-line
    function updateStory(e: any) {
      if (e) story.value = e.story;
    }

    let storyblokConnected = false;

    async function initStoryblok() {
      if (!storyblokConnected) {
        storyblokConnected = true;
        if (!process.env.VUE_APP_BUILD_OFFLINE) {
          await pingEditor();
          if (isInEditor()) {
            storyblokEventManager.addEventListener('change', getStoryDraft);
            storyblokEventManager.addEventListener('input', updateStory);
            await getStoryDraft();
          } else if (!props.editorOnly) {
            await getStoryPublished();
          }
        } else if (!props.editorOnly) {
          // VUE_APP_BUILD_OFFLINE using file protocol
          await getStoryPublished();
        }
      }
    }

    function disconnectStoryblok() {
      if (storyblokConnected) {
        storyblokConnected = false;
        storyblokEventManager.removeEventListener('change', getStoryDraft);
        storyblokEventManager.removeEventListener('input', updateStory);
      }
    }

    // TODO Add Server side rendering support without onActivated
    onActivated(initStoryblok);
    onMounted(initStoryblok);
    onDeactivated(disconnectStoryblok);
    onUnmounted(disconnectStoryblok);

    watch(
      () => props.slug,
      async () => {
        await pingEditor();
        if (isInEditor()) {
          await getStoryDraft();
        } else if (!props.editorOnly) {
          await getStoryPublished();
        }
      }
    );

    return {
      story,
    };
  },
});
